import { User } from "lucide-react";
import moment from "moment";

const VersionMetadata = ({
  created_at,
  author,
}: {
  created_at: string;
  author: string | undefined;
}) => (
  <div className="ml-6 flex items-center justify-between">
    <div className="truncate overflow-ellipsis py-0.5 text-xs text-gray-500">
      <span>{moment(created_at).fromNow()}</span>
      {author && (
        <>
          <span className="px-1 text-gray-400">•</span>
          <User className="inline h-3 w-auto pr-1" />
          <span className="truncate overflow-ellipsis">{author}</span>
        </>
      )}
    </div>
  </div>
);

export default VersionMetadata;
